document.addEventListener('DOMContentLoaded', function() {
  const elSearchForms = document.querySelectorAll('.js-search-form');
  elSearchForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const searchEnties = [];

      // キーワードが設定されていない場合は何もしない、存在する場合は検索条件に含める
      const searchQuery = this.querySelector('[name="q"]')?.value;
      if (!searchQuery) return;

      searchEnties.push({
        "q": encodeURIComponent(searchQuery)
      });

      // Shopifyのデフォルトオプションが設定されている場合はそれも検索条件に含める
      const defaultOptionNames = ['type', 'options[prefix]', 'options[unavailable_products]'];
      for (const name of defaultOptionNames) {
        const el = this.querySelector(`[name="${name}"]`);
        if (el) {
          searchEnties.push({
            [name]: encodeURIComponent(el.value)
          });
        }
      }

      // ユーザーのパラメーターが設定されている場合はそれも検索条件に含める
      const customerParam = this.dataset.customerParamValue;
      if (customerParam) {
        searchEnties.push({
          "filter.p.m.control.display_customer": customerParam
        });
      }

      // sort_byがURLに設定されている場合はそれも検索条件に含める
      const sortBy = new URL(window.location.href).searchParams.get('sort_by');
      if (sortBy) {
        searchEnties.push({
          "sort_by": encodeURIComponent(sortBy)
        });
      }

      const paramString = searchEnties.map(entry => {
        return Object.entries(entry).map(([key, value]) => `${key}=${value}`);
      }).join('&');

      const url = `${this.action}?${paramString}`;
      window.location.href = url;
    });
  });
});